import { Box, Typography, Link } from '@mui/material';
import { useHistory } from 'react-router-dom';

import AlertErrorIcon from 'assets/images/svg/AlertError.svg';
import { CampaignChannels } from 'domains/campaigns/types';
import { ContentTypeForComparison } from 'domains/content/types';
import { getContentCreatePath } from 'pages/ContentPage/ContentTable/utils';

type Props = {
    contentId?: number | null;
    channel?: CampaignChannels;
};

// Map CampaignChannels to ContentTypeForComparison
const channelToContentType: Record<string, ContentTypeForComparison> = {
    [CampaignChannels.EMAIL]: ContentTypeForComparison.EMAIL,
    [CampaignChannels.SMS]: ContentTypeForComparison.SMS,
    [CampaignChannels.DIRECT_MAIL]: ContentTypeForComparison.DIRECT_MAIL,
    [CampaignChannels.VOICE_CALL]: ContentTypeForComparison.VOICE,
    [CampaignChannels.WHATSAPP]: ContentTypeForComparison.WHATSAPP,
};

const ContentUnavailableAlert = ({ contentId, channel }: Props) => {
    const history = useHistory();

    const handleGoToContent = () => {
        if (contentId && channel) {
            const contentType = channelToContentType[channel] || ContentTypeForComparison.EMAIL;
            const path = getContentCreatePath({
                contentType,
                id: contentId,
            });
            history.push(path);
        }
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1400, // Above most MUI components
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'error.background',
                padding: '12px 24px',
                boxSizing: 'border-box',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                <Box component="img" src={AlertErrorIcon} alt="Alert" sx={{ width: 22, height: 22, flexShrink: 0 }} />
                <Typography
                    variant="body2"
                    sx={{
                        color: 'error.content',
                    }}
                >
                    Previously selected content has been unpublished or deleted. You can either publish it or select a
                    different content.
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
                {contentId && channel && (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={handleGoToContent}
                        sx={{
                            color: 'error.content',
                            textDecoration: 'none',
                            fontWeight: 500,
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Go To Content
                    </Link>
                )}
            </Box>
        </Box>
    );
};

export default ContentUnavailableAlert;
